<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <div>
        <ejs-dropdownbutton v-if='batch' :items='add' iconCss='icon hero-icon hero-icon-batch-add' :select='dropDown'></ejs-dropdownbutton>
        <div v-if="addBtn">
          <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-add" :title="this.$t('SubscriberIms.add')" @click="notices('add')" />-->
          <button :title='$t("SubscriberIms.add")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='notices("add")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-add e-icons"></span>
          </button>
        </div>
        <div v-if="editBtn">
          <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-edit" :title="this.$t('SubscriberIms.mod')" @click="notices('edit')" />-->
          <button :title='$t("SubscriberIms.mod")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='notices("edit")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-edit e-icons"></span>
          </button>
        </div>
        <div v-if="delBtn">
          <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-remove" :title="this.$t('SubscriberIms.del')" @click="notices('del')" />-->
          <button :title='$t("SubscriberIms.del")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='notices("del")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-remove e-icons"></span>
          </button>
        </div>
        <div v-if="refreshBtn">
          <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-refresh" :title="this.$t('SubscriberIms.fresh')" @click="notices('refresh')" />-->
          <button :title='$t("SubscriberIms.fresh")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='notices("refresh")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-refresh e-icons"></span>
          </button>
        </div>
        <div v-if='searchBtn' class="e-toolbar-item e-separator" aria-disabled="false"></div>
        <div v-if='searchBtn'>
          <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-search" :title="$t('SubscriberIms.search')" @click='buttonClk("search")'/>-->
          <button :title='$t("SubscriberIms.search")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='notices("search")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-search e-icons"></span>
          </button>
        </div>
      </div>
    </ejs-toolbar>
    <div v-if="keywordsInputTemplate" class="h-inputBox">
      <ejs-textbox v-model="keywordTemplate" :placeholder="this.$t('SubscriberIms.insertName')" @keydown.native.enter="transfer2ParentTemplate" maxLength='20'></ejs-textbox>
    </div>
    <div v-if="keywordsInputStaff" class="h-inputBox">
      <ejs-textbox v-model="keywordStaff" :placeholder="this.$t('SubscriberIms.insertStaffName')" @keydown.native.enter="transfer2ParentStaff" maxLength='20'></ejs-textbox>
    </div>
    <div v-if="dropdownList" class="h-inputBox" style='margin-left: 13px'>
      <ejs-dropdownlist ref="list" :dataSource="listDataSource" :index='0' @change="transfer2ParentTemplate"></ejs-dropdownlist>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToolBar",
  props: {
    batch: { type: Boolean, default: false },
    addBtn: { type: Boolean, default: false },
    delBtn: { type: Boolean, default: false },
    editBtn: { type: Boolean, default: false },
    refreshBtn: { type: Boolean, default: false },
    searchBtn: { type: Boolean, default: false },
    keywordsInputTemplate: { type: Boolean, default: false },
    keywordsInputStaff: { type: Boolean, default: false },
    dropdownList: { type: Boolean, default: false },
    listDataSource: { tyep: Array, default: () => [] }
  },
  data() {
    return {
      keywordTemplate: "",
      keywordStaff: "",
      add: [
        {
          text: this.$t("SubscriberIms.userTemplate"),
          value: 0
        },
        {
          text: this.$t("SubscriberIms.groupTemplate"),
          value: 1
        }],
    };
  },
  methods: {
    notices(args) {
      if (args === "refresh") {
        if(this.keywordsInputTemplate){
          this.keywordTemplate = "";
          this.transfer2ParentTemplate();
        }
        else if(this.keywordsInputStaff){
          this.keywordStaff = "";
          this.transfer2ParentStaff();
        }
      }
      this.$emit("notice", args);
    },
    transfer2ParentTemplate() {
      let key = '';
      let index = 0;
      if (this.keywordsInputTemplate) {
        key = this.keywordTemplate;
      }
      if (this.dropdownList) {
        index = this.$refs.list.ej2Instances.index;
      }
      this.$emit("props", {
        keywordTemplate: key,
        listIndex: index
      });
    },
    transfer2ParentStaff() {
      let key = '';
      let index = 0;
      if (this.keywordsInputStaff) {
        key = this.keywordStaff;
      }
      this.$emit("props", {
        keywordStaff: key,
        listIndex: index
      });
    },
    dropDown(it) {
      this.$emit('methodEnum', it.item.value);
    }
  },
  mounted() {
    if(this.keywordsInputTemplate){
      this.transfer2ParentTemplate();
    }
    else if(this.keywordsInputStaff){
      this.transfer2ParentStaff();
    }
  }
};
</script>
